"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@material-ui/core/styles");
const useStyles = (0, _styles.makeStyles)(theme => ({
  phoneContainer: {},
  phoneContainerAB: {},
  phoneMultiple: {},
  phoneHint: {
    marginTop: 4,
    fontSize: 12
  },
  phoneNum: {},
  buttonRoot: {
    padding: "8px 20px",
    [theme.breakpoints.up("sm")]: {
      display: "none"
    }
  },
  buttonLabel: {
    fontSize: 16,
    lineHeight: "20px"
  }
}));
var _default = useStyles;
exports.default = _default;